/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  ExternalDimensioningConfigurationFragmentDoc,
  ExternalDimensioningResultFragmentDoc
} from "./external-dimensioning.fragments.generated"
import { ProductConfigurationModelsFragmentDoc } from "./product-configuration.fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ExternalDimensioningResultQueryVariables = Exact<{
  id: string
}>

export type ExternalDimensioningResultQuery = {
  __typename: "Query"
  externalDimensioningResult?: {
    __typename: "ExternalDimensioningResult"
    transactionId: string
    environmentalVars?: Array<any> | null
    variantKeyData?: any
    dllVersion?: string | null
    language?: string | null
    technicalData?: Array<
      | {
          __typename: "ExternalDimensioningTechnicalDataDllVersion"
          dllVersion: string
        }
      | {
          __typename: "ExternalDimensioningTechnicalDataTable"
          header?: Array<string> | null
          content?: any
          summary?: string | null
          type?: string | null
        }
    > | null
    technicalInput?: Array<{
      __typename: "ExternalDimensioningTechnicalInput"
      name: string
      label?: string | null
      unit?: string | null
      value?: any
      userSelected: boolean
    }> | null
    supplementaryText?: Array<{
      __typename: "ExternalDimensioningSupplementaryText"
      text: string
    }> | null
    transferData?: {
      __typename: "ExternalDimensioningTransferData"
      origin?: string | null
    } | null
  } | null
}

export type ExternalDimensioningModelsQueryVariables = Exact<{
  [key: string]: never
}>

export type ExternalDimensioningModelsQuery = {
  __typename: "Query"
  externalDimensioningModels?: {
    __typename: "ProductConfigurationModels"
    models?: Array<{
      __typename: "ProductConfigurationModel"
      id?: string | null
      dimUrl?: Array<{
        __typename: "ProductConfigurationModelDimInfo"
        label: string
        url: string
      }> | null
      followUps?: Array<{
        __typename: "ProductConfigurationModelFollowUp"
        id?: string | null
        dimUrl?: Array<{
          __typename: "ProductConfigurationModelDimInfo"
          label: string
          url: string
        }> | null
      }> | null
    }> | null
  } | null
}

export type ExternalDimensioningConfigurationQueryVariables = Exact<{
  productType: string
  dimensioningKey: string
}>

export type ExternalDimensioningConfigurationQuery = {
  __typename: "Query"
  externalDimensioningConfiguration?: {
    __typename: "ExternalDimensioningConfiguration"
    id: string
    variantKey: string
    dimensioningKey: string
    productType: string
    accessories: Array<string>
    errors?: Array<{
      __typename: "APIError"
      code: string
      message?: string | null
      cause?: any
    }> | null
  } | null
}

export const ExternalDimensioningResultDocument = gql`
  query ExternalDimensioningResult($id: ID!) {
    externalDimensioningResult(id: $id)
      @rest(
        type: "ExternalDimensioningResult"
        endpoint: "dimensioningDataExchange"
        path: "/{args.id}"
      ) {
      ...ExternalDimensioningResult
    }
  }
  ${ExternalDimensioningResultFragmentDoc}
`

/**
 * __useExternalDimensioningResultQuery__
 *
 * To run a query within a React component, call `useExternalDimensioningResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDimensioningResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDimensioningResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExternalDimensioningResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  > &
    (
      | { variables: ExternalDimensioningResultQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  >(ExternalDimensioningResultDocument, options)
}
export function useExternalDimensioningResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  >(ExternalDimensioningResultDocument, options)
}
// @ts-ignore
export function useExternalDimensioningResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningResultQuery,
  ExternalDimensioningResultQueryVariables
>
export function useExternalDimensioningResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningResultQuery,
        ExternalDimensioningResultQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningResultQuery | undefined,
  ExternalDimensioningResultQueryVariables
>
export function useExternalDimensioningResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningResultQuery,
        ExternalDimensioningResultQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ExternalDimensioningResultQuery,
    ExternalDimensioningResultQueryVariables
  >(ExternalDimensioningResultDocument, options)
}
export type ExternalDimensioningResultQueryHookResult = ReturnType<
  typeof useExternalDimensioningResultQuery
>
export type ExternalDimensioningResultLazyQueryHookResult = ReturnType<
  typeof useExternalDimensioningResultLazyQuery
>
export type ExternalDimensioningResultSuspenseQueryHookResult = ReturnType<
  typeof useExternalDimensioningResultSuspenseQuery
>
export type ExternalDimensioningResultQueryResult = Apollo.QueryResult<
  ExternalDimensioningResultQuery,
  ExternalDimensioningResultQueryVariables
>
export const ExternalDimensioningModelsDocument = gql`
  query ExternalDimensioningModels {
    externalDimensioningModels
      @rest(
        type: "ProductConfigurationModels"
        endpoint: "productConfigurationModels"
        path: "/dimensioning"
      ) {
      ...ProductConfigurationModels
    }
  }
  ${ProductConfigurationModelsFragmentDoc}
`

/**
 * __useExternalDimensioningModelsQuery__
 *
 * To run a query within a React component, call `useExternalDimensioningModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDimensioningModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDimensioningModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalDimensioningModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >(ExternalDimensioningModelsDocument, options)
}
export function useExternalDimensioningModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >(ExternalDimensioningModelsDocument, options)
}
// @ts-ignore
export function useExternalDimensioningModelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningModelsQuery,
  ExternalDimensioningModelsQueryVariables
>
export function useExternalDimensioningModelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningModelsQuery,
        ExternalDimensioningModelsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningModelsQuery | undefined,
  ExternalDimensioningModelsQueryVariables
>
export function useExternalDimensioningModelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningModelsQuery,
        ExternalDimensioningModelsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ExternalDimensioningModelsQuery,
    ExternalDimensioningModelsQueryVariables
  >(ExternalDimensioningModelsDocument, options)
}
export type ExternalDimensioningModelsQueryHookResult = ReturnType<
  typeof useExternalDimensioningModelsQuery
>
export type ExternalDimensioningModelsLazyQueryHookResult = ReturnType<
  typeof useExternalDimensioningModelsLazyQuery
>
export type ExternalDimensioningModelsSuspenseQueryHookResult = ReturnType<
  typeof useExternalDimensioningModelsSuspenseQuery
>
export type ExternalDimensioningModelsQueryResult = Apollo.QueryResult<
  ExternalDimensioningModelsQuery,
  ExternalDimensioningModelsQueryVariables
>
export const ExternalDimensioningConfigurationDocument = gql`
  query ExternalDimensioningConfiguration(
    $productType: String!
    $dimensioningKey: String!
  ) {
    externalDimensioningConfiguration(
      productType: $productType
      dimensioningKey: $dimensioningKey
    )
      @rest(
        type: "ExternalDimensioningConfiguration"
        path: "/product-configuration/models/{args.productType}/dimensioning?dimensioningKey={args.dimensioningKey}"
      ) {
      ...ExternalDimensioningConfiguration
    }
  }
  ${ExternalDimensioningConfigurationFragmentDoc}
`

/**
 * __useExternalDimensioningConfigurationQuery__
 *
 * To run a query within a React component, call `useExternalDimensioningConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDimensioningConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDimensioningConfigurationQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      dimensioningKey: // value for 'dimensioningKey'
 *   },
 * });
 */
export function useExternalDimensioningConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  > &
    (
      | {
          variables: ExternalDimensioningConfigurationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  >(ExternalDimensioningConfigurationDocument, options)
}
export function useExternalDimensioningConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  >(ExternalDimensioningConfigurationDocument, options)
}
// @ts-ignore
export function useExternalDimensioningConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningConfigurationQuery,
  ExternalDimensioningConfigurationQueryVariables
>
export function useExternalDimensioningConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningConfigurationQuery,
        ExternalDimensioningConfigurationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ExternalDimensioningConfigurationQuery | undefined,
  ExternalDimensioningConfigurationQueryVariables
>
export function useExternalDimensioningConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExternalDimensioningConfigurationQuery,
        ExternalDimensioningConfigurationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ExternalDimensioningConfigurationQuery,
    ExternalDimensioningConfigurationQueryVariables
  >(ExternalDimensioningConfigurationDocument, options)
}
export type ExternalDimensioningConfigurationQueryHookResult = ReturnType<
  typeof useExternalDimensioningConfigurationQuery
>
export type ExternalDimensioningConfigurationLazyQueryHookResult = ReturnType<
  typeof useExternalDimensioningConfigurationLazyQuery
>
export type ExternalDimensioningConfigurationSuspenseQueryHookResult =
  ReturnType<typeof useExternalDimensioningConfigurationSuspenseQuery>
export type ExternalDimensioningConfigurationQueryResult = Apollo.QueryResult<
  ExternalDimensioningConfigurationQuery,
  ExternalDimensioningConfigurationQueryVariables
>
